import React, { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import Layout from "../../components/Layout";
import LanguageContext from "../../helper/LanguageContext";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import { callAPI } from "../../helper/apiUtils";
import LocationSearchInput from "../../components/LocationSearchInput";
import { $crud } from "../../helper/CrudFactory";
import { ReactComponent as EditIcon } from "../../Icons/Edit-grey.svg";
import { ReactComponent as TrashIcon } from "../../Icons/Trash-grey.svg";
import moment from "moment";
import { BASE_URL, goBack } from "../../helper/constants";
import CompanyRoles from "./Dialogs/CompanyRoles";
import { Roles } from "../../Languages/vars/Roles";
import { a, useHistory } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";
import { useCurrentUserProfileData } from "../../helper/UserFactory";
import { Animated } from "react-animated-css";
import { convertBranchRole } from "../../helper/convertor";
import { getCompanyRoles, loadCustomBranches } from "../../helper/customBranches";
import ModernToggleSwitch from "../../components/ModernToggleSwitch";
import "./FreeCapacity.css";

const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    backgroundColor: "rgba(var(--kjuup-accent-rgb), 0.8)",
  };
  return (
    <div
      className="thumb-style"
      style={{ ...style, ...thumbStyle }}
      {...props}
    />
  );
};

const CustomScrollbars = (props) => (
  <Scrollbars
    renderThumbHorizontal={renderThumb}
    renderThumbVertical={renderThumb}
    {...props}
  />
);

function FreeCapacity() {
  const { isGerm, strings } = React.useContext(LanguageContext);
  const [companyRoles, setCompanyRoles] = useState(Roles);
  useEffect(() => {
    loadCustomBranches().then(() => setCompanyRoles(getCompanyRoles()));
  }, []);
  const [display, setDisplay] = useState("0");
  const [showRoleDialog, setRoleDialog] = useState(false);
  const [followStatus, setFollowStatus] = useState(false);
  const [reportParams, setReportParams] = useState({
    id: "",
    services: "",
    country: "",
    city: "",
    lat: "",
    long: "",
    circuit: "100",
    buildingIndustryRole: "",
    companyId: "",
    from: moment().format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD'),
  });
  const [searchParams, setSearchParams] = useState({
    country: "",
    city: "",
    lat: "",
    long: "",
    circuit: "100",
    buildingRole: "",
    from: moment().format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD'),
  });
  const [suggestionLoaded, setSuggestionLoaded] = useState(false);
  const [capsFound, setCapFound] = useState(false);
  const [capacities, setCapacities] = useState([]);
  const [searchCapacities, setSearchCapacities] = useState([]);
  const [companiesObject, setCompaniesObject] = useState({
    companies: [],
    isOnlyOneCompany: false,
  });
  const handleClass = async (index) => {
    if (index === "2") {
      if (companiesObject.companies.length > 0) {
        if (display === index) {
          await setDisplay(null);
        } else {
          await setDisplay(index);
        }
      } else {
        await setDisplay(null);
        await $crud.notify({
          type: "warning",
          message: !isGerm ? "Please register for a company with a position that allows to report capacities" : 'Bitte ihr Profil mit einer Firma verknüpfen, um Leistungen anzubieten.',
        });
      }
    } else {
      if (display === index) {
        await setDisplay(null);
      } else {
        await setDisplay(index);
      }
    }
    console.log(display);
  };
  const getCompanies = async () => {
    const { data } = await callAPI("/user/company", {}, "GET");
    if (!data.isOnlyOneCompany) {
      setCompaniesObject(data);
      await getCompanyDetails(data?.companies?.[0]?.id);
    } else {
      setCompaniesObject(data);
      await getCompanyDetails(data?.companies?.[0]?.id);
    }
  };

  const getCompanyDetails = async (id) => {
    console.log(id);
    const { data } = await callAPI(`/company/${id}/companyById`, {}, "GET");
    console.log(data);
    setReportParam("companyId", data?.company?.id);
    setReportParam("buildingIndustryRole", data?.company?.branch);
  };
  const getCapacities = async () => {
    const { data } = await callAPI(`/capacity`, {}, "GET");
    setCapacities(data.capacities);
  };

  const setReportParam = (name, value) => {
    setReportParams((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const setSearchParam = (name, value) => {
    setSearchParams((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const deleteReportCapacity = async (id) => {
    await $crud.confirm({
      title: strings.confirm,
      textContent: strings.delete_capacity_confirm || "Do you really want to delete the reported capacity?",
      options: {
        ok: strings.yes,
        cancel: strings.no,
      },
    });
    const { data } = await callAPI(
      "/capacity/" + id,
      {
        id: id,
      },
      "DELETE"
    );
    if (data.status) {
      $crud.notify({
        type: "success",
        message: data.message,
      });
      const updatedCapacities = capacities.filter(
        (capacity) => capacity.id !== id
      );
      setCapacities(updatedCapacities);
    }
    console.log(data);
  };

  useEffect(() => {
    getCapacities();
    getCompanies();
  }, []);

  const reportCapacities = async () => {
    console.log(reportParams);
    const { data } = await callAPI("/capacity", reportParams, "POST");
    $crud.notify({
      type: data.status ? "success" : "error",
      message: data.message,
    });
    if (data.status) {
      setReportParams({
        id: "",
        services: "",
        country: "",
        city: "",
        lat: "",
        long: "",
        circuit: "100",
        buildingIndustryRole: "",
        companyId: "",
        from: "",
        to: "",
      });
      getCapacities();
      setDisplay("0");
    }
  };
  const updateReportCapacities = async () => {
    const { data } = await callAPI(
      "/capacity/" + reportParams.id,
      reportParams,
      "PUT"
    );
    $crud.notify({
      type: data.status ? "success" : "error",
      message: data.message,
    });

    if (data.status) {
      setReportParams({
        id: "",
        services: "",
        country: "",
        city: "",
        lat: "",
        long: "",
        circuit: "100",
        buildingIndustryRole: "",
        companyId: "",
        from: "",
        to: "",
      });
      getCapacities();
      setDisplay("0");
    }
  };
  const updateCapacityStatus = async (id) => {
    const { data } = await callAPI("/capacity/" + id + "/status", {}, "PUT", {
      id: id,
    });
    $crud.notify({
      type: data.status ? "success" : "error",
      message: data.message,
    });
    const updatedCapacityStatusList = capacities.map((capacity) => {
      if (capacity.id === id) {
        capacity.isActive = !capacity.isActive;
      }
      return capacity;
    });
    setCapacities(updatedCapacityStatusList);
  };

  const setCapacityValue = async (capacity) => {
    console.log(capacity);
    setDisplay("2");
    setReportParams((prev) => {
      return {
        ...prev,
        id: capacity.id,
        services: capacity.services,
        country: capacity.country,
        city: capacity.city,
        lat: capacity.lat,
        long: capacity.long,
        circuit: capacity.circuit,
        buildingIndustryRole: capacity.buildingIndustryRole,
        companyId: capacity.companyId,
        from: moment(capacity.from).format("YYYY-MM-DD"),
        to: moment(capacity.to).format("YYYY-MM-DD"),
      };
    });
    console.log(reportParams);
  };
  const changeRole = (roles) => {
    const selectedRoles = roles.join(",");
    console.log(roles);
    setSearchParam("buildingRole", selectedRoles);
  };

  const searchCapacity = async () => {
    console.log("searchParams=>", searchParams)
    let tempData = { ...searchParams, buildingRole: convertBranchRole(searchParams?.buildingRole, false) }
    const { data } = await callAPI(`/capacity/find`, {}, "POST", tempData);
    if (data.status) {
      setSearchCapacities(data.capacities);
      setCapFound(true);
    } else {
      $crud.notify({
        type: "error",
        message: data.message,
      });
    }
  };
  const followCompany = async (id) => {
    setFollowStatus(true);
    const { data } = await callAPI(
      `/company/${id}/follow`,
      {
        id: id,
      },
      "GET"
    );
    $crud.notify({
      type: data.status ? "success" : "error",
      message: data.message,
    });
    setFollowStatus(false);
    searchCapacity();
  };
  const history = useHistory();
  const getCompany = (companyId) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const profile = useCurrentUserProfileData();
    const { companies } = profile;
    if (companies.length > 0) {
      const getId = companies.find((c) => c.id === companyId);
      if (getId) {
        history.push({
          pathname: "/cockpit",
          search: `?tab=company&company=${encodeURIComponent(getId.id)}`,
        });
      } else {
        history.push({
          pathname: `/foreign-company-details/${companyId}`,
        });
      }
    } else {
      history.push({
        pathname: `/foreign-company-details/${companyId}`,
      });
    }
  };
  const [visible, setVisible] = useState(true);
  const handleBack = () => {
    setVisible(false);
    setTimeout(() => {
      goBack();
    }, 1000);
  };
  return (
    <React.Fragment>
      <Layout>
        <Animated
          animationIn="slideInLeft"
          animationOutDuration={800}
          isVisible={true}
        >
          {!capsFound && (
            <div className="w-300 capacities_content-page pb-0 free-capacity__page">
              <h5>
                <img
                  className="pointer"
                  onClick={handleBack}
                  width={10}
                  src={process.env.PUBLIC_URL + "/assets/img/back.svg"}
                  alt="Generic placeholder"
                />{" "}
                {strings.free_capacity}
              </h5>
              <div className="row">
                <div className="setting_accrd col-12 pl-0 pr-0">
                  <Accordion>
                    <Card>
                      <Card.Header
                        variant="link"
                        eventKey="0"
                        onClick={(e) => handleClass("0")}
                        className="pl-3"
                      >
                        {strings.current_status_overview}
                        {display === "0" && <BsChevronUp className="acr_up" />}
                        {display !== "0" && (
                          <BsChevronDown className="acr_down" />
                        )}
                      </Card.Header>
                      {display === "0" && (
                        <Card.Body>
                          {capacities &&
                            capacities.map((capacity) => (
                              <div key={capacity.id} className="row m-0">
                                <div className="col-2 p-2">
                                  {capacity.logo ? (
                                    <img
                                      className="b-r-4 free-capacity__status-logo"
                                      width={40}
                                      height={40}
                                      src={BASE_URL + capacity.logo}
                                      alt="Generic placeholder"
                                    />
                                  ) : (
                                    <div className="company_img_placeholder" aria-hidden="true">
                                      <span className="material-symbols-outlined">image</span>
                                    </div>
                                  )}
                                </div>
                                <div className="col-7 p-2">
                                  <p className="theme-color m-0 small">
                                    {capacity.companyName}
                                  </p>
                                  <p className="m-0 small">{capacity.city}</p>
                                  <p className="m-0 small">
                                    {capacity.services}
                                  </p>
                                </div>
                                <div className="col-3 p-2 text-right">
                                  <EditIcon
                                    onClick={(e) => setCapacityValue(capacity)}
                                    height={30}
                                    className="custom-svg active mr-3 pointer free-capacity__edit-icon"
                                  />
                                  <TrashIcon
                                    onClick={(e) =>
                                      deleteReportCapacity(capacity.id)
                                    }
                                    height={20}
                                    className="custom-svg active pointer"
                                  />
                                </div>
                                <div className="col-9 p-2">
                                  <p className="small">
                                    {moment(capacity.from).format(
                                      "DD. MMMM YYYY"
                                    )}{" "}
                                    -{" "}
                                    {moment(capacity.to).format(
                                      "DD. MMMM YYYY"
                                    )}
                                  </p>
                                </div>
                                <div className="col-3 p-2 text-right project-checkbox">
                                  <ModernToggleSwitch
                                    onChange={(e) =>
                                      updateCapacityStatus(capacity.id)
                                    }
                                    checked={capacity.isActive}
                                    id={capacity.id}
                                    variant="orange"
                                  />
                                </div>
                              </div>
                            ))}
                        </Card.Body>
                      )}
                    </Card>
                    <Card>
                      <Card.Header
                        variant="link"
                        eventKey="1"
                        onClick={(e) => handleClass("1")}
                        className="pl-3"
                      >
                        {strings.search_capacities}
                        {display === "1" && <BsChevronUp className="acr_up" />}
                        {display !== "1" && (
                          <BsChevronDown className="acr_down" />
                        )}
                      </Card.Header>
                      {display === "1" && (
                        <Card.Body className="p-3">
                          <Form
                            className="add_company_from"
                            onSubmit={(e) => {
                              e.preventDefault();
                              searchCapacity();
                            }}
                          >
                            <Form.Group
                              className={
                                showRoleDialog
                                  ? "select_coustom position-relative theme-border"
                                  : "select_coustom position-relative gray-border"
                              }
                            >
                              <a
                                className="register_role pointer text-truncate xyz"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setRoleDialog(!showRoleDialog);
                                }}
                              >
                                {!searchParams.buildingRole && (
                                  <span>
                                    {strings.role_in_the_building_industry}
                                    {"*"}
                                  </span>
                                )}
                                {searchParams.buildingRole && (
                                  <span>{searchParams.buildingRole}</span>
                                )}
                              </a>
                              <BsChevronDown size={12} />
                              <div className="profile-edit-roles">
                                {showRoleDialog && (
                                  <CompanyRoles
                                    hideRoles={(e) => {
                                      setRoleDialog(false);
                                    }}
                                    selectPosition={changeRole}
                                    position={companyRoles}
                                  />
                                )}
                              </div>
                            </Form.Group>
                            <Form.Group controlId="formBasicEmail">
                              <Form.Control
                                type="text"
                                placeholder={strings.services}
                              />
                            </Form.Group>
                            <Form.Group controlId="formBasicEmail">
                              <LocationSearchInput
                                suggestionLoaded={
                                  suggestionLoaded && searchParams.city
                                    ? true
                                    : false
                                }
                                defaultValue={searchParams.city}
                                placeHolder={
                                  strings.city
                                }
                                isFreeCapacity={true}
                                setParam={setSearchParam}
                              />
                            </Form.Group>

                            <div className="row">
                              <div className="col-md-5 pr-1">
                                <Form.Group controlId="formBasicPassword">
                                  <Form.Control
                                    value={searchParams.circuit}
                                    onChange={(e) =>
                                      setSearchParam("circuit", e.target.value)
                                    }
                                    as="select"
                                    custom
                                  >
                                    <option value={30}>30 Km</option>
                                    <option value={40}>50 Km</option>
                                    <option value={100}>100 Km</option>
                                    <option value={200}>200 Km</option>
                                    <option value={500}>500 Km</option>
                                    <option value={1000}>National</option>
                                    <option value={2000}>International</option>
                                  </Form.Control>
                                </Form.Group>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-8">
                                <Form.Group controlId="formBasicPassword">
                                  <Form.Control
                                    value={searchParams.from}
                                    onChange={(e) =>
                                      setSearchParam("from", e.target.value)
                                    }
                                    type="date"
                                    placeholder="Start date* "
                                  />
                                </Form.Group>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-8">
                                <Form.Group controlId="formBasicPassword">
                                  <Form.Control
                                    type="date"
                                    value={searchParams.to}
                                    onChange={(e) =>
                                      setSearchParam("to", e.target.value)
                                    }
                                    placeholder="End date* "
                                  />
                                </Form.Group>
                              </div>
                            </div>

                            <button className="kj-btn kj-btn--outline" type="submit">
                              {strings.find}
                            </button>

                            <p className="m-0 small free-capacity__hint">
                              {strings.mandetory}
                            </p>

                          </Form>
                        </Card.Body>
                      )}
                    </Card>
                    <Card>
                      <Card.Header
                        variant="link"
                        eventKey="2"
                        onClick={(e) => handleClass("2")}
                        className="pl-3"
                      >
                        {strings.report_capacities}
                        {display === "2" && <BsChevronUp className="acr_up" />}
                        {display !== "2" && (
                          <BsChevronDown className="acr_down" />
                        )}
                      </Card.Header>
                      {display === "2" && (
                        <Card.Body className="p-3">
                          {display === "2" ? (
                            <Form
                              className="add_company_from"
                              onSubmit={(e) => {
                                e.preventDefault();
                                reportParams.id
                                  ? updateReportCapacities()
                                  : reportCapacities();
                              }}
                            >
                              {!companiesObject.isOnlyOneCompany &&
                                companiesObject.companies.length > 0 && (
                                  <Form.Group controlId="formBasicEmail">
                                    <Form.Control
                                      as="select"
                                      value={reportParams.companyId}
                                      custom
                                      onChange={(e) =>
                                        getCompanyDetails(e.target.value)
                                      }
                                    >
                                      {companiesObject.companies &&
                                        companiesObject.companies.map(
                                          (company) => (
                                            <option
                                              key={company.id}
                                              value={company.id}
                                            >
                                              {company.name}
                                            </option>
                                          )
                                        )}
                                    </Form.Control>
                                  </Form.Group>
                                )}
                              <Form.Group controlId="formBasicEmail">
                                <Form.Control
                                  value={reportParams.services}
                                  onChange={(e) =>
                                    setReportParam("services", e.target.value)
                                  }
                                  type="text"
                                  placeholder={
                                    strings.services
                                  }
                                />
                              </Form.Group>

                              <Form.Group controlId="formBasicEmail">
                                <LocationSearchInput
                                  suggestionLoaded={
                                    suggestionLoaded && reportParams.city
                                      ? true
                                      : false
                                  }
                                  defaultValue={reportParams.city}
                                  placeHolder={
                                    strings.city
                                  }
                                  isFreeCapacity={true}
                                  setParam={setReportParam}
                                />
                              </Form.Group>

                              <div className="row">
                                <div className="col-md-5 pr-1">
                                  <Form.Group controlId="formBasicPassword">
                                    <Form.Control
                                      value={reportParams.circuit}
                                      onChange={(e) =>
                                        setReportParam(
                                          "circuit",
                                          e.target.value
                                        )
                                      }
                                      as="select"
                                      custom
                                    >
                                      <option value={30}>30 Km</option>
                                      <option value={40}>50 Km</option>
                                      <option value={100}>100 Km</option>
                                      <option value={200}>200 Km</option>
                                      <option value={500}>500 Km</option>
                                      <option value={1000}>National</option>
                                      <option value={2000}>
                                        International
                                      </option>
                                    </Form.Control>
                                  </Form.Group>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-8">
                                  <Form.Group controlId="formBasicPassword">
                                    <Form.Control
                                      value={reportParams.from}
                                      onChange={(e) =>
                                        setReportParam("from", e.target.value)
                                      }
                                      type="date"
                                      placeholder="Start date* "
                                    />
                                  </Form.Group>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-8">
                                  <Form.Group controlId="formBasicPassword">
                                    <Form.Control
                                      type="date"
                                      value={reportParams.to}
                                      onChange={(e) =>
                                        setReportParam("to", e.target.value)
                                      }
                                      placeholder="End date* "
                                    />
                                  </Form.Group>
                                </div>
                              </div>

                              <button className="kj-btn kj-btn--outline" type="submit">
                                {reportParams.id
                                  ? "Update"
                                  : strings.report_text}
                              </button>
                              <p className="m-0 small free-capacity__hint">
                                {strings.mandetory}
                              </p>
                            </Form>
                          ) : (
                            ""
                          )}
                        </Card.Body>
                      )}
                    </Card>
                  </Accordion>
                </div>
              </div>
            </div>
          )}
          {capsFound && (
            <div className="w-300 capacities_content-page pb-0">
              <h5 onClick={(e) => setCapFound(false)}>
                <img
                  className="pointer"
                  width={10}
                  src={process.env.PUBLIC_URL + "assets/img/back.svg"}
                  alt="Generic placeholder"
                />{" "}
                {strings.search_results}
              </h5>
              <div className="my-scroll min_height capacities_height">
                <CustomScrollbars
                  autoHide
                  autoHideTimeout={500}
                  autoHideDuration={200}
                  className="bottom-bar"
                >
                  {searchCapacities &&
                    searchCapacities.map((capacity, index) => (
                      <div className="content-capi">
                        <div className="capacities_content">
                          {capacity.logo ?
                            <img
                              width={40}
                              src={BASE_URL + capacity.logo}
                              alt="Generic placeholder"
                              className="free-capacity__result-logo"
                            />
                            :
                            <img width="45" height="45" src="assets/img/Companies-No-Image.svg" alt="Generic placeholder" className="free-capacity__result-placeholder" />
                          }
                          <div className="right_capacities">
                            <h4
                              className="pointer"
                              onClick={(e) => getCompany(capacity.companyId)}
                            >
                              {capacity.companyName}
                            </h4>
                            <p>Service: {capacity.services}</p>
                            <p>Branch:{capacity.buildingIndustryRole?.split(",")?.map((item, index) => (index ? ", " : "") + convertBranchRole(item, isGerm))}</p>
                            <p>
                              Location: {capacity.street}, {capacity.city},{" "}
                              {capacity.country}
                            </p>
                            <p>Radius: {capacity.circuit}Km</p>
                          </div>
                        </div>
                        <div className="timeframe">
                          <div className="row">
                            <div className="col-md-9">
                              <div className="timeframe-content">
                                <p>Timeframe:</p>
                                <p className="small">
                                  {moment(capacity.from).format(
                                    "DD. MMMM YYYY"
                                  )}{" "}
                                  -{" "}
                                  {moment(capacity.to).format("DD. MMMM YYYY")}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-3 pl-0">
                              <div className="frame-icon">
                                <a
                                  onClick={(e) => {
                                    followCompany(capacity.companyId);
                                  }}
                                  className={`pointer ${capacity.followStatus
                                    ? "social-icon-active"
                                    : ""
                                    } ${followStatus ? "active-like-follow" : ""
                                    } free-capacity__follow`}
                                >
                                  <span
                                    className={`material-symbols-outlined mr-1 free-capacity__follow-icon${capacity.followStatus ? " free-capacity__follow-icon--active" : ""}`}
                                  >
                                    person_heart
                                  </span>
                                </a>
                                <a href={`mailto:${capacity.companyEmail}`}>
                                  <img
                                    width={27}
                                    src={
                                      process.env.PUBLIC_URL +
                                      "assets/img/e-mail-grey.svg"
                                    }
                                    alt="Generic placeholder"
                                  />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </CustomScrollbars>
              </div>
            </div>
          )}
        </Animated>
      </Layout>
    </React.Fragment>
  );
}

export default FreeCapacity;
